import {Outlet} from "react-router-dom"
import React from "react";

function Order() {
 
  return <Outlet />;
}

export default Order;
